<template>
  <b-modal
    ref="create-workspace-modal"
    modal-class="b-modal lg"
    centered
    content-class="create-workspace-modal"
    title="New Workspace"
    visible
    @hide="$emit('close-create-workspace-modal')"
  >
    <template slot="modal-header">
      <div class="text-center">
        <h4 class="i-text-heading-4 i-text-neutral-120 i-mb-2">
          New Workspace
        </h4>
        <h5 class="i-text-body-2 i-text-neutral-110 i-mb-0">
          Note that this step cannot be undone. Learn more about
          <!-- eslint-disable-next-line prettier/prettier -->
          creating Workspaces at our
          <a
            href="https://help.inscribe.ai/en/articles/6719171-workspaces"
            target="_blank"
            rel="noopener"
            >Help Center</a
          >.
        </h5>
      </div>
    </template>
    <div class="workspace-name-field">
      <label
        for="key-name"
        class="i-text-subheading-2 i-text-neutral-120 i-mb-2"
        >Name</label
      >
      <b-form-input
        id="key-name"
        v-model="workspaceName"
        data-testid="workspace-name-field"
        placeholder="Enter Workspace Name"
        class="i-form-input i-text-neutral-120"
        :class="{ error: hasError }"
      ></b-form-input>
      <div class="i-mt-4 i-text-body-3 i-text-error-110">
        <p v-if="hasError">Workspace name already exists</p>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <i-button
        text="Cancel"
        type="neutral"
        subtype="subtle"
        size="lg"
        class="i-mr-6"
        @button-click="$emit('close-create-workspace-modal')"
      ></i-button>
      <i-button
        text="Create Workspace"
        size="lg"
        :disabled="hasError"
        data-testid="create-new-workspace-button"
        @button-click="createNewWorkspace()"
      ></i-button>
    </div>
    <template slot="modal-footer"> &nbsp; </template>
  </b-modal>
</template>

<script>
import { iButton } from '@inscribe/signal';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  components: {
    iButton,
  },
  data() {
    return {
      workspaceName: undefined,
    };
  },
  computed: {
    ...mapState(['workspaces']),

    hasError() {
      const workSpaceNames = this.workspaces.map((workspace) => {
        return workspace.name;
      });
      return workSpaceNames.includes(this.workspaceName);
    },
  },
  methods: {
    ...mapActions(['createWorkspace']),
    ...mapMutations(['updateWorkspaces']),

    createNewWorkspace() {
      const created = this.createWorkspace(this.workspaceName);

      created.then((response) => {
        this.updateWorkspaces(response.data);
        this.$emit('close-create-workspace-modal');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.workspace-name-field {
  margin-bottom: 40px;
}
</style>
